<template>
  <i :style="{ fontSize: `${size}px`, color }" :class="[`ci-${icon}`]" class="c-icon" />
</template>

<script>
  import Vue from 'vue';

  // TODO: Consider to configure Vuetify with custom icon set
  // https://v2.vuetifyjs.com/en/features/icon-fonts/#using-custom-icons
  export default Vue.extend({
    name: 'C360Icon',

    props: {
      /**
       * Icon name from the coolicons set.
       */
      icon: {
        type: String,
        required: true,
      },

      /**
       * Size of icon.
       */
      size: {
        type: Number,
        default: 24,
      },

      color: {
        type: String,
      }
    },
  });
</script>

<style scoped>
  .c-icon {
    font-size: 24px;
  }
</style>
